import { useEffect } from 'react'

import { useExperimentsContext } from '../components/ExperimentsContext'
import { useGetExperiment } from '../hooks'
import { EXPERIMENT_NAME_ZERO_EURO_COPAYMENT_TOGGLE } from '../model/EXPERIMENT_NAME'

export const useActivateZeroEuroCopaymentExperiment = (
  isExposed: boolean,
): void => {
  const { isEnabled } = useGetExperiment(
    EXPERIMENT_NAME_ZERO_EURO_COPAYMENT_TOGGLE,
  )
  const { addExperimentKeysForActivation } = useExperimentsContext()

  useEffect(() => {
    if (!isEnabled || !isExposed) {
      return
    }

    addExperimentKeysForActivation(EXPERIMENT_NAME_ZERO_EURO_COPAYMENT_TOGGLE)
  }, [addExperimentKeysForActivation, isEnabled, isExposed])
}
